<div [id]="name" [ngClass]="class_map"></div>